import { toast } from "react-toastify";
import { API_FACTURAS_DESGUACES } from "../views/MainLayout/components/shared/services/facturas_desguaces";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialFacturasDesguaces =  []

export const facturasDesguacesReducer = (state = initialFacturasDesguaces, action) => {
    switch(action.type){
        case "facturas_desguaces/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchFacturasDesguaces = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_FACTURAS_DESGUACES.getFacturas(page, search)
        const data = await response.data;
        dispatch({ type: 'facturas_desguaces/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}